import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Divider,
  Stack,
} from '@mui/material';
import type { ReactNode } from 'react';

import { SidePanelPropsTable } from '@/components/panels/sidePanelPropsTable';
import { type FormattedField } from '@/components/table/hooks';

export const FieldsSection = ({
  fields,
  title,
  columnSpace,
  defaultExpanded,
  children,
}: {
  fields: FormattedField[];
  title: string;
  columnSpace?: 'small' | 'medium' | 'large';
  defaultExpanded?: boolean;
  children?: ReactNode;
}) => {
  if (fields.length === 0 && !children) {
    return null;
  }

  return (
    <MuiAccordion disableGutters defaultExpanded={defaultExpanded}>
      <MuiAccordionSummary data-testid='operation-summary'>
        {title}
      </MuiAccordionSummary>
      <MuiAccordionDetails sx={{ padding: '24px 0' }}>
        <Stack divider={<Divider />} gap='16px'>
          <SidePanelPropsTable withDividers columnSpace={columnSpace}>
            <tbody>
              {fields.map((field) => (
                <tr key={field.id}>
                  <td className='props-col'>{field.title}</td>
                  <td className='break-all'>{field.Component}</td>
                </tr>
              ))}
            </tbody>
          </SidePanelPropsTable>
          {children}
        </Stack>
      </MuiAccordionDetails>
    </MuiAccordion>
  );
};
